const customTheme = {
  palette: {
    grey: "#8c8c8c",
  },

  box: {
    logo: {
      backgroundImage: `url("../assets/logo.png)`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: 300,
    },
  },

  typography: {
    fontFamily: '"Montserrat", sans-serif',
    memberheader: {
      fontFamily: "Montserrat",
      fontSize: "19px",
      fontWeight: "500",
      marginBottom: "10px",
    },
    moneytext: {
      fontFamily: "Montserrat",
      fontSize: "30px",
      fontWeight: "600",
    },
    listfont: {
      fontFamily: "Montserrat",
      fontSize: "13px",
      fontWeight: "700",
    },

    faqQ: {
      fontFamily: "Montserrat",
      fontSize: "13px",
      fontWeight: "800",
    },

    faqA: {
      fontFamily: "Montserrat",
      fontSize: "13px",
      fontWeight: "400",
    },

    captionmod: {
      marginTop: "5px",
      fontSize: "12px",
      textAlign: "center",
      //   width: "fit",
      //   display: "flex",
      fontWeight: "800",
    },

    accordianhead: {
      fontFamily: "Montserrat",
      fontSize: "13px",
      fontWeight: "800",
    },

    logosame: {
      fontFamily: "Montserrat",
      textAlign: "center",
      fontSize: "25px",
      fontWeight: "700",
    },

    walletConnected: {
      marginTop: "5px",
      fontFamily: "Montserrat",
      fontSize: "12px",
      fontWeight: "500",
    },

    headingcon: {
      fontFamily: "Montserrat",
      fontWeight: "600",
      fontSize: "20px",
    },

    cardhrdtxt: {
      fontFamily: "Montserrat",
      fontSize: "15px",
      fontWeight: "700",
    },
  },
  stack: {
    toolstack: {
      margin: "20px",
    },
  },
};

export default customTheme;
